import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { BaseComponent } from './components/base/base.component';
import { LoginComponent } from './components/login/login.component';
import { CommonService } from './services/common.service';
import { navItems } from './classes/nav-items';
import { systemMessages } from '../assets/SystemMessages';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends BaseComponent implements OnInit {

  version: string;
  pageTitle: any[] = [];
  routes: any;
  loadingWebsite: boolean;

  @ViewChild("sidenav") sidenav: MatSidenav;

  public static pageTitleBehavior = new BehaviorSubject<string>(null);//for a custom page title if needed

  constructor(private router: Router, private route: ActivatedRoute, private commonService: CommonService) {
    super();
    this.version = "v" + this.CONFIG.VERSION;
    this.loadingWebsite = true;
  }

  ngOnInit() {
    setTimeout(() => {
      this.loadingWebsite = false;
    }, 500);//so view doesn't switch quickly

    //get system labels and transform their object
    let translations = {};
    for (let msg of systemMessages) {
      translations[msg.code] = {
        descAr: msg.descAr,
        descEn: msg.descEn
      };
    }
    this.translationService.setTranslations(translations);

    setTimeout(() => {
      this.loadingWebsite = false;
    }, 500);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.router.routerState.root.firstChild != null) {
          this.pageTitle = [];
          let urlParts = event.url.split("/"); //urlParts is in this format ==> ["", "parent", "child"]
          this.pageTitle.push({ value: 'home', isClickable: true, path: '/', isHome: true });
          var totalPath = '';
          urlParts.forEach((element: any) => {
            if (urlParts.indexOf(element) != 0) {
              totalPath += this.translatePipe.getLabel(element) + '/';

              let pageTitleSlug = {
                value: element,
                isClickable: urlParts.indexOf(element) == urlParts.length - 1 ? false : true,
                path: totalPath,
                isHome: false
              }
              this.pageTitle.push(pageTitleSlug);
            }
          });
          totalPath = '';
        }
      }
    });

    this.authorizationService.user.subscribe(user => {
      this.getRoutes();
    });

    AppComponent.pageTitleBehavior.subscribe(data => {
      setTimeout(() => {
      }, 250);
    });
  }

  navClickListener(route: Route) {
    if (route.children?.length) {
      route.data.isExpanded = !route.data.isExpanded;
    } else {
      this.sidenav.toggle();
      this.routes.forEach(element => {
        if (element.data.hasOwnProperty("isExpanded")) {
          element.data.isExpanded = false;
        }
      });
    }
  }

  getRoutes(): void {
    this.routes = navItems.filter(e => !e.data.hide);
    if (this.user) {
      //remove components depending on privileges
      this.routes = this.routes.filter(e => {
        if (e.data.requireUser) {
          if (!e.data.right || this.user.Privileges.includes(e.data.right)) {
            return true;
          }
        } else {//routes for public users
          if (e.component != LoginComponent) {//routes to hide for logged in users
            return true;
          }
        }
        return false;
      });
    } else {
      this.routes = this.routes.filter(e => !e.data.requireUser);
    }
  }

}
